import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import './style.scss';

export default function ReturnArrow(props) {
  const history = useHistory();

  const handleBack = () => {
    if (props.previousLink) {
      history.push(props.previousLink);
    } else {
      props.getPreviousStep();
    }
  };

  return (
    <div>
      {!props.hideButton && (
        <div className="arrow-back" onClick={() => handleBack()}>
          <ArrowBackIcon />
          <p>Retour </p>
        </div>
      )}
    </div>
  );
}
